export default "__VITE_ASSET__CysaM2Sv__"